import { render, staticRenderFns } from "./radio-tertiary.vue?vue&type=template&id=4e24d08a&scoped=true"
import script from "./radio-tertiary.vue?vue&type=script&lang=js"
export * from "./radio-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e24d08a",
  null
  
)

export default component.exports